import { makeStyles } from "tss-react/mui";
import { Theme247 } from "../styles/Theme247";
import {
  Breadcrumbs,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import i18n from "../reducers/i18n";
import { useEffect, useMemo, useState } from "react";
import { ApplyStyle as _s } from "../utils/ApplyStyle";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ScopeHeader from "../components/ScopeHeader";
import {
  createArea,
  updateArea,
  deleteArea,
  getsitesareaeqs2,
  setsitesareaeqs2Empty,
  createEqPoolMap,
  getallsitesareaeqs,
  updateAreaShifts,
  createAreaShifts,
} from "../actions/objects";
import { connect, useStore } from "react-redux";
import { ReactComponent as SmallWerke } from "../assets/smallWerke.svg";
import { ReactComponent as EuroSvg } from "../assets/Euro.svg";
import store from "../store";
import { hasMalfunction } from "../shared-functions/notification";
import { truncateWithEllipses } from "../utils/helpers";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

import machineFallbackImage from "../assets/machine-example.png";

import { MachineCardItem } from "247factorynet-packages";
import "247factorynet-packages/dist/index.css";
import PoolcheckBoxesDialog from "./PoolCheckboxesDialog";

import { uniqBy } from "lodash";
import DeletePopUp from "../components/DeletePopup";
import { Stack } from "@mui/system";

import LinkOffIcon from "@mui/icons-material/LinkOff";
import ShiftsModel from "./ShiftsModel";
import { Euro } from "@mui/icons-material";
import moment from "moment";

export default connect(
  ({
    subscribedAreas,
    subscribedEquipments,
    allsitesareaseqs,
    subscribedSites,
    subscribedSitesNodeIds,
  }) => ({
    subscribedAreas,
    subscribedSites,
    subscribedEquipments,
    allsitesareaseqs,
    getallsitesareaeqs,
    subscribedSitesNodeIds,
  }),
  {
    createArea,
    updateArea,
    deleteArea,
    getsitesareaeqs2,
    getallsitesareaeqs,
    setsitesareaeqs2Empty,
    createEqPoolMap,
    createAreaShifts,
    updateAreaShifts,
  }
)((props) => {
  const useStyles = makeStyles()((theme) => ({
    elevatedSection: {
      ...Theme247.elevatedSection,
    },
  }));

  const { classes } = useStyles();

  const [ids, setIds] = useState("");

  let location = useLocation();

  const language = useStore().getState().language;

  const [poolModel, setPoolModel] = useState(false);

  const [selectedCheckBoxes, setSelectedCheckboxes] = useState(0);

  const [searchText, setSearchText] = useState("");

  const [filteredItems, setFilteredItems] = useState("");

  const [childModelData, setChildModelData] = useState([]);

  const [modelData, setModelData] = useState([]);

  const [editPayload, setEditPayload] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();

  const [eqStunde, setEqStunde] = useState();

  const [defaultIds, setDefaultIds] = useState([]);

  const [weekShifts, setWeekShifts] = useState([]);

  const [uiVersion, setUIVersion] = useState("");

  let editMode = searchParams.get("nodeid") !== null;

  const [betriebsparameter, setBetriebsparameter] = useState("");
  const [betriebszeiten, setBetriebszeiten] = useState("");

  const navigate = useNavigate();

  let targetNodeId = searchParams.get("nodeid");
  let targetArea = editMode && props.subscribedAreas[targetNodeId];

  const [areaName, setAreaName] = useState(targetArea ? targetArea.name : "");

  let defaultChecked = targetArea
    ? targetArea.hasequipment &&
      targetArea.hasequipment.map((ids) => {
        return ids.equipment.nodeid;
      })
    : [];

  const [poolName, setPoolName] = useState(targetArea ? targetArea?.name : "");

  const handleClick = () => {
    setPoolModel(true);
  };

  const [checkedItems, setCheckedItems] = useState({});

  const [showSkeliton, setShowSkeliton] = useState(true);

  const [openDialogDelete, setopenDialogDelete] = useState();

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const getStarEndUnix = (shift) => {
    const { start, end } = shift;

    let startHour = start.split(":")[0];
    let endHour = end.split(":")[0];
    let endMinutes = end.split(":")[1];

    let startShift,
      endShift = 0;

    if (startHour > endHour) {
      // calculate time for next day

      let tempValue = moment(timeToMilliseconds(start)).add(
        24 - Math.abs(startHour - endHour),
        "hour"
      );
      tempValue = new Date(tempValue).setMinutes(endMinutes);
      startShift = timeToMilliseconds(start);
      endShift = moment(tempValue).unix() * 1000;
    } else {
      startShift = timeToMilliseconds(start);
      endShift = timeToMilliseconds(end);
    }
    return { startShift, endShift };
  };

  const makeShiftsPayload = (data) => {
    let result = [];
    if (data.length) {
      result = data.map((shift) => {
        const { startShift, endShift } = getStarEndUnix(shift);
        return [{}, startShift, endShift, shift.weekdays, shift.unmanned];
      });
    }
    return result;
  };

  const createArea = () => {
    props.createArea({
      lang: store.getState().language,
      name: areaName,
      areaid: ids,
      sitenodeid: location.state.nodeid,
      isSiteSubs: Object.keys(props?.subscribedSitesNodeIds).includes(
        location.state.nodeid
      ),
      assign: {
        payload: editPayload,
      },
    });

    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
      props.getallsitesareaeqs("", "ALL_SAE");
    }, 2000);
    navigate("/sites?sitenodeid=" + location.state.sitenodeid);
  };

  const editArea = () => {
    /* console.log(editPayload); */

    props.updateArea({
      lang: store.getState().language,
      name: areaName,
      areaid: ids,
      sitenodeid: location.state.nodeid,
      areanodeid: targetArea.nodeid,
    });

    // add shifts to shifts model

    let shifts = makeShiftsPayload(weekShifts);

    if (shifts.length && !location.state.hasshiftmodel) {
      props.createAreaShifts({
        shifts: shifts,
        shiftmodelof: targetArea.nodeid,
      });
    }

    // update shifts to shifts model

    if (location.state.hasshiftmodel) {
      props.updateAreaShifts({
        shifts: shifts,
        shiftnodeid: location.state.hasshiftmodel[0].shiftmodel.nodeid,
      });
    }

    props.createEqPoolMap({
      payload: editPayload,
    });

    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
    }, 2000);
    navigate("/sites?sitenodeid=" + location.state.sitenodeid);
  };

  const getUnLinkedEquipments = () => {
    let unlinkedEquipments = [];
    let allEquipments = getAllEquipments();

    let allLegalEntityEquipments =
      props.allsitesareaseqs[1]?.data[0]?.legalentity?.hasequipment;

    if (allLegalEntityEquipments?.length) {
      allLegalEntityEquipments.map((eqItem) => {
        let targetEq = allEquipments.filter((eq) => {
          return eq.id === eqItem.equipment.nodeid;
        });

        if (allEquipments && targetEq.length === 0) {
          unlinkedEquipments.push({
            id: eqItem.equipment.nodeid,
            eqName: eqItem.equipment.name,
            eqId: eqItem.equipment.equipmentid,
            brandName: eqItem.equipment?.hasequipmenttype
              ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                  ?.isequipmenttypeof[0]?.brand?.name
              : "",
            typIdentifier: eqItem.equipment?.hasequipmenttype
              ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype?.model
              : "",
            icon: <LinkOffIcon />,
          });
        }
      });
    }

    return unlinkedEquipments;
  };

  const getAllEquipments = () => {
    let equipments = [];

    // Grab Equipments from areas
    props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite?.map(
      (siteItem, key) => {
        siteItem.site?.hasarea &&
          siteItem.site.hasarea.map((areaItem) => {
            areaItem.area?.hasequipment &&
              areaItem.area.hasequipment.map((eqItem) => {
                equipments.push({
                  id: eqItem.equipment.nodeid,
                  eqName: eqItem.equipment.name,
                  eqId: eqItem.equipment.equipmentid,
                  brandName: eqItem.equipment?.hasequipmenttype
                    ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.isequipmenttypeof[0]?.brand?.name
                    : "",
                  typIdentifier: eqItem.equipment?.hasequipmenttype
                    ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.model
                    : "",
                });
              });
          });
      }
    );

    // Grab Equipments from pool

    props.allsitesareaseqs[0]?.data[0]?.legalentity.hasequipmentpool?.map(
      (poolItem, key) => {
        poolItem.equipmentpool?.hasequipment &&
          poolItem.equipmentpool.hasequipment.map((eqItem) => {
            equipments.push({
              id: eqItem.equipment.nodeid,
              eqName: eqItem.equipment.name,
              eqId: eqItem.equipment.equipmentid,
              brandName: eqItem.equipment?.hasequipmenttype
                ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                    ?.isequipmenttypeof[0]?.brand?.name
                : "",
              typIdentifier: eqItem.equipment?.hasequipmenttype
                ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                : "",
            });
          });
      }
    );

    return equipments;
  };

  const makeCheckBoxes = () => {
    let modelData = [];

    props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite?.map(
      (siteItem, key) => {
        siteItem.site?.hasarea &&
          siteItem.site.hasarea.map((areaItem) => {
            areaItem.area?.hasequipment &&
              areaItem.area.hasequipment.map((eqItem, index) => {
                modelData.push({
                  id: eqItem.equipment.nodeid,
                  eqName: eqItem.equipment.name,
                  eqId: eqItem.equipment.equipmentid,
                  brandName: eqItem.equipment?.hasequipmenttype
                    ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.isequipmenttypeof[0]?.brand?.name
                    : "",
                  typIdentifier: eqItem.equipment?.hasequipmenttype
                    ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.model
                    : "",
                });
              });
          });
      }
    );

    // Grab Equipments from pool

    props.allsitesareaseqs[0]?.data[0]?.legalentity.hasequipmentpool?.map(
      (poolItem, key) => {
        poolItem.equipmentpool?.hasequipment &&
          poolItem.equipmentpool.hasequipment.map((eqItem, index) => {
            modelData.push({
              id: eqItem.equipment.nodeid,
              eqName: eqItem.equipment.name,
              eqId: eqItem.equipment.equipmentid,
              brandName: eqItem.equipment?.hasequipmenttype
                ? eqItem.equipment?.hasequipmenttype[0]?.equipmenttype
                    ?.isequipmenttypeof[0]?.brand?.name
                : "",
              typIdentifier: eqItem.equipment?.hasequipmenttype
                ? eqItem?.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                : "",
            });
          });
      }
    );

    if (modelData.length) {
      modelData[modelData.length - 1].className = "eqLast";
    }

    let unLinkedEquipments = getUnLinkedEquipments();

    if (unLinkedEquipments.length) {
      unLinkedEquipments[0].className = "eqUnlinked";
      modelData = [...modelData, ...unLinkedEquipments];
      modelData[modelData.length - 1].className = "eqLast";
    }

    setModelData(modelData);
  };

  const getSelectedCheckBoxes = (ids) => {
    let eqs = [];
    Object.entries(props.subscribedEquipments).map((eqPool) => {
      let key = eqPool[0];
      let value = eqPool[1];
      if (ids.includes(value.nodeid)) {
        eqs.push(value);
      }
    });
    setDefaultIds(eqs);
  };

  // Function to convert "HH:MM" to milliseconds
  const timeToMilliseconds = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    let date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return moment(date).unix() * 1000;
  };

  const getExistingShifts = (data) => {
    // preparing pre load data
    return data.map((shift) => {
      let start_time = new Date(shift[1]).toLocaleTimeString();
      let start_hours = start_time.split(":")[0];
      let start_minutes = start_time.split(":")[1];

      start_time = start_hours + ":" + start_minutes;

      let end_time = new Date(shift[2]).toLocaleTimeString();
      let end_hours = end_time.split(":")[0];
      let end_minutes = end_time.split(":")[1];

      end_time = end_hours + ":" + end_minutes;

      return {
        start: start_time,
        end: end_time,
        unmanned: shift[4],
        weekdays: shift[3],
        startUnix: timeToMilliseconds(start_time),
        endUnix: timeToMilliseconds(end_time),
      };
    });
  };

  useEffect(() => {
    props.setsitesareaeqs2Empty("", "ALL_SAE_EMPTY");
    props.getsitesareaeqs2("", "SAE2");
    props.getallsitesareaeqs("", "ALL_SAE");
    makeCheckBoxes();

    if (location.state.pageType === "edit") {
      if (location.state.hasshiftmodel) {
        let shifts = location.state.hasshiftmodel[0].shiftmodel.shifts;
        if (shifts.length) {
          let data = getExistingShifts(shifts);
          if (data.length) {
            setWeekShifts(data);
          }
        }
      }
    }

    setTimeout(() => {
      setShowSkeliton(false);
    }, 2000);
  }, []);

  useEffect(() => {
    // Grab Equipments from site
    makeCheckBoxes();
  }, [props]);

  let uniqueMachines = uniqBy(modelData, "id");

  /* console.log(
    uniqueMachines,
    "uniqueMachines",
    props.allsitesareaseqs[0]?.data[0]
  ); */

  const filterareaByMachine = (eqNodeId) => {
    let str = "";
    props.allsitesareaseqs[0]?.data[0]?.legalentity.hassite?.map(
      (siteItem, key) => {
        siteItem.site?.hasarea &&
          siteItem.site.hasarea.map((areaItem) => {
            areaItem.area?.hasequipment &&
              areaItem.area.hasequipment.map((eqItem) => {
                if (eqItem.equipment.nodeid === eqNodeId) {
                  str = areaItem.area.nodeid;
                }
              });
          });
      }
    );
    return str;
  };

  const getCheckBoxData = (data) => {
    setChildModelData(data);
    let finalPayload = [];

    if (defaultChecked && defaultChecked.length) {
      for (const [key, value] of Object.entries(data)) {
        let filteredNodeId = filterareaByMachine(key);

        /* console.log(filteredNodeId, "nodeid"); */

        //delete
        if (
          defaultChecked.includes(key) &&
          value === false &&
          targetArea.nodeid !== ""
        ) {
          finalPayload.push({
            equipmentnodeid: key,
            isequipmentof: [],
            deleteequipmentof: [{ type: "area", nodeid: targetArea.nodeid }],
          });
        }

        //add
        if (!defaultChecked.includes(key) && value === true) {
          finalPayload.push({
            equipmentnodeid: key,
            isequipmentof: [targetArea.nodeid],
            deleteequipmentof:
              filteredNodeId !== ""
                ? [{ type: "area", nodeid: filterareaByMachine(key) }]
                : [],
          });
        }
      }
    } else {
      for (const [key, value] of Object.entries(data)) {
        if (value === true) {
          //add
          finalPayload.push({
            equipmentnodeid: key,
            isequipmentof: [targetArea.nodeid],
            deleteequipmentof: [
              { type: "area", nodeid: filterareaByMachine(key) },
            ],
          });
        }
      }
    }

    // console.log(finalPayload,"===> finalPayload")
    setEditPayload(finalPayload);
  };

  const handleDelete = () => {
    props.deleteArea({ areanodeid: targetArea.nodeid });

    setTimeout(() => {
      props.getsitesareaeqs2("", "SAE2");
      props.getallsitesareaeqs("", "ALL_SAE");
    }, [3000]);

    navigate(-1);
  };

  // const handleEqStunde = (e) => {
  //   setEqStunde(e.target.value);
  // };

  let hasError = weekShifts.length
    ? weekShifts.filter((shift) => {
        return shift.weekdays.length === 0;
      })[0]
      ? true
      : false
    : false;

  // console.log(weekShifts);

  const isEditMode = location.state.pageType === "edit";
  const originalShifts = useMemo(() => {
    if (!location.state.hasshiftmodel?.[0]?.shiftmodel?.shifts?.length) {
      return [];
    }
    return getExistingShifts(location.state.hasshiftmodel[0].shiftmodel.shifts);
  }, [location.state.hasshiftmodel]);
  const isAreaDirty = useMemo(() => {
    if (!editMode) {
      return String(areaName || "").trim() !== "";
    }

    return (
      String(areaName || "").trim() !== String(targetArea?.name || "").trim() ||
      editPayload.length > 0 ||
      JSON.stringify(weekShifts || []) !== JSON.stringify(originalShifts || [])
    );
  }, [editMode, areaName, targetArea, editPayload, weekShifts, originalShifts]);

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" className={_s(Theme247.breadcrumbs)}>
        <div
          onClick={() => {
            navigate(-1);
          }}
          style={{ color: "rgba(0, 0, 0, 0.38)", display: "flex" }}
        >
          <ArrowBackIcon size="large" />
          {i18n().backLink}
        </div>
      </Breadcrumbs>

      <ScopeHeader
        bgColor="#0E3F51"
        bgImage="../images/bg1.webp"
        txtColor="#FFFFFF"
        title="Bereiche"
        description="Ihr Werk kann in beliebig viele Bereiche eingeteilt werden, welchen Ihr Equipment zugewiesen ist."
      />

      <PoolcheckBoxesDialog
        items={uniqueMachines}
        setPoolModel={setPoolModel}
        poolModel={poolModel}
        getCheckBoxData={getCheckBoxData}
        defaultChecked={defaultChecked}
        getSelectedCheckBoxes={getSelectedCheckBoxes}
      />

      <Paper
        elevation={Theme247.elevationLow}
        className={classes.elevatedSection}
        style={{ padding: "0px" }}
      >
        <div className="createSite">
          <div style={{ padding: "28px 24px 0px 24px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                }}
              >
                <div>
                  <SmallWerke fontSize={5} />
                </div>
                <div className="smallCaption">{location.state.sitename}</div>
              </div>

              <div>
                {editMode ? (
                  <Button
                    variant="contained"
                    color="error"
                    size="large"
                    startIcon={<DeleteForeverOutlinedIcon />}
                    onClick={() => {
                      setopenDialogDelete(true);
                    }}
                    // className={_s(Theme247.submitButton)}
                    sx={{
                      width: "100%",
                      color: "rgba(255, 61, 0, 1)",
                      border: "1px solid rgba(0, 0, 0, 0.12)",
                      borderRadius: "4px",
                      background: "#ffffff",
                      ":hover": { color: "#ffffff" },
                    }}
                  >
                    {/* {i18n.delete}
                     */}
                    Bereich löschen
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="_title">{ isEditMode ? i18n().update_area_title : i18n().create_area_title}</div>

            <Grid container spacing={2} sx={{ margin: "20px 0px" }}>
              <Grid item xs={5} style={{ padding: 0 }}>
                <TextField
                  value={areaName}
                  fullWidth
                  onChange={(e) => {
                    setAreaName(e.target.value);
                  }}
                  label={"Name des Bereichs"}
                  variant="outlined"
                  helperText={"z.B.: Gehäusefertigung"}
                  inputProps={{ "data-testid": "txtf_area_name"}}
                />
              </Grid>
            </Grid>
          </div>

          <Divider orientation="horizontal" sx={{ margin: "24px 0px" }} />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0px 24px",
              alignItems: "center",
            }}
          >
            <div className="footerTitle">
              <div>Zugeordnetes Equipment</div>
              <div className="bxShadow counterCircle">
                {targetArea?.hasequipment === undefined
                  ? "0"
                  : targetArea?.hasequipment
                  ? targetArea?.hasequipment?.length
                  : Object.values(childModelData).filter((val) => {
                      return val === true;
                    }).length}
              </div>
            </div>
            <div>
              <Button
                variant="outlined"
                onClick={() => {
                  handleClick();
                }}
                data-testid="btn_assign_equipments"
              >
                Equipment AUSWÄHLEN
              </Button>
            </div>
          </div>

          {targetNodeId && showSkeliton ? (
            <div style={{ padding: "0px 24px" }}>
              <Stack spacing={1}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "23px",
                    width: "100%",
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    width={"50%"}
                    height={97}
                    animation="wave"
                    style={{ marginRight: "23px" }}
                  />

                  <Skeleton
                    variant="rounded"
                    width={"50%"}
                    height={97}
                    animation="wave"
                  />
                </div>
              </Stack>
            </div>
          ) : (
            ""
          )}

          <div className="eqPool" style={{ padding: " 0px 24px" }}>
            {defaultIds.map((y) => {
              return (
                <MachineCardItem
                  borderColor={hasMalfunction(y?.hasnotification)}
                  title={truncateWithEllipses(
                    y?.name[language] != undefined
                      ? y?.name[language]
                      : y?.name,
                    40
                  )}
                  description={` ${
                    y?.hasequipmenttype[0]?.equipmenttype?.isequipmenttypeof !==
                    undefined
                      ? y?.hasequipmenttype[0]?.equipmenttype
                          ?.isequipmenttypeof[0]?.brand?.name
                      : ""
                  } ${y?.hasequipmenttype[0]?.equipmenttype?.model}`}
                  imageSrc={
                    Object.keys(y.image).length !== 0 &&  y?.image != null && y?.image.fileid !== ""
                      ? y?.image.url
                      : machineFallbackImage
                  }
                  className=""
                />
              );
            })}
          </div>
        </div>

        <Divider orientation="horizontal" sx={{ margin: "0px 0px 30px 0px" }} />

        {/* <div style={{ padding: "0px 24px" }} className="eq_stunde">
          <div className="footerTitle">
            <div>Betriebsparameter</div>
          </div>
        <>
          {/* <div style={{ padding: "0px 24px" }} className="eq_stunde uiV1">
            <div className="footerTitle">
              <div>Betriebsparameter</div>
            </div>
            <FormControlLabel
              sx={{ height: 80 }}
              control={
                <Checkbox
                  checked={betriebsparameter}
                  onChange={(e) => setBetriebsparameter(e.target.checked)}
                />
              }
              label={
                <div className="ckeckboxLabel">
                  <div className="title">
                    Einstellungen aus Bereich übernehmen
                  </div>
                  {uiVersion === "v2" ? (
                    <div className="areaName">
                      Es wurden noch keine Betriebsparameter für den Bereich{" "}
                      {areaName} festgelegt. <span>Konfigurieren</span>
                    </div>
                  ) : (
                    <div className="desc">
                      Bitte wählen Sie einen Bereich aus
                    </div>
                  )}
                </div>
              }
            />
          </div> */}

        {/* {uiVersion === "v3" ? (
            <div
              style={{ padding: "0px 24px 24px 24px" }}
              className="eq_stunde uiV1"
            >
              <FormControl fullWidth>
                <InputLabel htmlFor="outlined-adornment-amount">
                  Equipment Stundensatz (optional)
                </InputLabel>
                <OutlinedInput
                  type="number"
                  label="Equipment Stundensatz (optional)"
                  placeholder="Equipment Stundensatz (optional)"
                  variant="outlined"
                  sx={{ width: "331px" }}
                  value={eqStunde}
                  onChange={handleEqStunde}
                  helperText="Pro Equipment überschreibbar"
                  endAdornment={
                    <InputAdornment position="end">
                      <EuroSvg />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
          ) : (
            ""
          )}

          <Divider
            orientation="horizontal"
            sx={{ margin: "10px 0px 30px 0px" }}
          />

          <div style={{ padding: "5px 24px" }} className="eq_stunde uiV1">
            <div className="footerTitle">
              <div>Betriebszeiten</div>
            </div>
            <FormControlLabel
              sx={{ height: 80 }}
              control={
                <Checkbox
                  checked={betriebszeiten}
                  onChange={(e) => setBetriebszeiten(e.target.checked)}
                />
              }
              label={
                <div className="ckeckboxLabel">
                  <div className="title">
                    Einstellungen aus Bereich übernehmen
                  </div>
                  {uiVersion === "v2" ? (
                    <div className="areaName">
                      Es wurden noch keine Betriebszeiten für den Bereich{" "}
                      {areaName} festgelegt. <span>Konfigurieren</span>
                    </div>
                  ) : (
                    <div className="desc">
                      Bitte wählen Sie einen Bereich aus
                    </div>
                  )}
                </div>
              }
            />
          </div> */}

        <div style={{ padding: "5px 24px" }} className="eq_stunde ">
          {location.state.pageType === "edit" ? (
            <ShiftsModel weekShifts={weekShifts} setWeekShifts={setWeekShifts} style={{ maxHeight: "25%"}} />
          ) : (
            ""
          )}
        </div>
      </Paper>

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
        topic="Bereich"
      ></DeletePopUp>

      <Button
        variant="contained"
        onClick={() => {
          editMode ? editArea() : createArea();
        }}
        style={{ marginBottom: "20%" }}
        disabled={areaName === "" || hasError || !isAreaDirty}
        data-testid="btn_create_area_submit"
      >
        {" "}
       {editMode ? "Änderungen Speichern" :  "Bereich anlegen"}
      </Button>
    </>
  );
});
